import type { AnyID } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'
import { degrees } from '@utils/generalMaths/geometry'
import { isCornerXLBrazoCatalog } from '@utils/sceneObjects/items/rinconeroUtils'
import { Matrix4, Quaternion, Vector3 } from 'three'
import { resnapModularSectionAfterRotate, type ResnapSectionStore } from './resnapSection'

/** Ángulo Y en grados (misma convención que editItemAngle / ItemAngleInput). */
export function readItemYAngleDegrees(matrix: Matrix4): number {
  const basisX = toVector3()
  matrix.extractBasis(basisX, toVector3(), toVector3())
  const xRot = toVector3([1, 0, 0]).angleTo(basisX)
  const crossProduct = toVector3([1, 0, 0]).cross(basisX)
  return (degrees(xRot * -Math.sign(crossProduct.y)) + 360) % 360
}

type RotateSectionStore = ResnapSectionStore & {
  editItemAngle: (id: AnyID, angle: number) => void
}

/** Gira 90° la sección en su pivote (origen del módulo), sin mover el origen. */
export function rotateModularSection90(
  itemId: AnyID,
  store: RotateSectionStore,
  options?: { resnapToNearest?: boolean },
): number | null {
  const item = store.items.get(String(itemId)) as { matrix?: Matrix4; type?: string } | undefined
  if (!item?.matrix || item.type !== 'linkedItem') return null

  const current = readItemYAngleDegrees(item.matrix)
  const next = (current + 90) % 360
  store.editItemAngle(itemId, next)

  const updated = store.items.get(String(itemId)) as { matrix?: Matrix4 } | undefined
  if (!updated?.matrix) return next

  store.setOBB(itemId)
  store.updateSelectedObjectsPosition(itemId, updated.matrix.clone())

  // En un Corner el re-snap devuelve la L a la fila y el giro no se ve.
  const catalog = (item as { catalogID?: unknown }).catalogID
  if (options?.resnapToNearest && !isCornerXLBrazoCatalog(catalog)) {
    resnapModularSectionAfterRotate(itemId, store)
  }

  return next
}
